import React from 'react';
import { Helmet } from "react-helmet";
import { FaSearchPlus, FaCogs, FaLink, FaMapMarkedAlt, FaChartArea, FaTerminal } from 'react-icons/fa';
import "./Seo.css";

const SEO = () => {
  return (
    <main className="service-page">
      <Helmet>
        {/* ✅ TITLE WITH DOMAIN BRANDING */}
        <title>SEO Engineering & Organic Growth | Skyline Bussiness Solutions</title>

        {/* ✅ META DESCRIPTION */}
        <meta 
          name="description" 
          content="Dominate search results with Skyline Bussiness Solutions. Visit skylinebussinesssolutions.com for expert SEO, keyword research, and high-authority link building." 
        />

        {/* ✅ CANONICAL URL */}
        <link rel="canonical" href="https://skylinebussinesssolutions.com/seo" />
      </Helmet>

      {/* HERO SECTION */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">SEARCH ENGINE ARCHITECTURE</span>
          <h1 className="service-display">
            Organic <br />
            <span className="accent-text">Growth Engineering</span>
          </h1>
          <p className="service-intro">
            At <strong>Skyline Bussiness Solutions</strong>, we don't just "optimize" for Google; we 
            <strong> reverse-engineer search algorithms</strong>. Visit us at 
            <strong> skylinebussinesssolutions.com</strong> to grow your business online.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* STRATEGY */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaTerminal /></div>
            <h3>Technical Rigor</h3>
            <p>Optimizing Core Web Vitals, Schema markup, and crawl budgets to ensure search bots prioritize your domain.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaSearchPlus /></div>
            <h3>Semantic Research</h3>
            <p>Advanced keyword strategy and topic clusters to boost rankings.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaLink /></div>
            <h3>Authority Building</h3>
            <p>High-quality backlinks and outreach strategies for domain authority.</p>
          </div>
        </section>

        {/* CAPABILITIES */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaCogs className="card-icon" />
            <h3>Technical SEO Audit</h3>
            <p>Complete website analysis for performance and ranking improvements.</p>
          </div>

          <div className="glass-card">
            <FaMapMarkedAlt className="card-icon" />
            <h3>Local SEO</h3>
            <p>Rank your business in "near me" searches with optimized listings.</p>
          </div>

          <div className="glass-card">
            <FaChartArea className="card-icon" />
            <h3>Analytics & Tracking</h3>
            <p>Monitor keyword rankings, traffic, and conversions.</p>
          </div>
        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>The Ranking Lifecycle</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Audit</h4>
              <p>Identify ranking issues and opportunities.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Optimize</h4>
              <p>Fix on-page SEO and technical errors.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Scale</h4>
              <p>Grow authority and traffic consistently.</p>
            </div>
          </div>
        </section>
      </div>

      {/* ✅ SCHEMA WITH DOMAIN */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "SEO & Organic Growth",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "url": "https://skylinebussinesssolutions.com/seo",
          "description": "Professional SEO services including audits, keyword research, and link building."
        })}
      </script>
    </main>
  );
};

export default SEO;